import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {format} from "react-string-format";
import {Col, Container, Row} from "react-bootstrap";

class CompanyRevenue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedPayouts: false,
            isLoadedData: false,
            userId: null,
            adminData: null,
            loginError: null,
            payouts: null,
            revenue: 0,
            revenueIsLoaded: false,
        };
    }

    loadRevenue(){
        fetch(process.env.REACT_APP_API_URL + "/admin/" + this.state.userId.toString(), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedData: true,
                        adminData: result
                    });

                    fetch(process.env.REACT_APP_API_URL + "/payouts/user/" + this.state.userId, {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    isLoadedPayouts: true,
                                    payouts: result
                                });
                            },

                            (error) => {
                                this.setState({
                                    isLoadedPayouts: false,
                                    error
                                });
                            }
                        )

                    fetch(process.env.REACT_APP_API_URL + "/financial-events/admin/" + result.id + "/total-amount", {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    revenueIsLoaded: true,
                                    revenue: result
                                });
                            },

                            (error) => {
                                this.setState({
                                    revenueIsLoaded: true,
                                    error
                                });
                            }
                        )
                },

                (error) => {
                    this.setState({
                        isLoadedData: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    console.log("logged");
                    if (result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        }, this.loadRevenue);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        loginError: "unauthorized",
                    });
                }
            );
    }

    approvePayout(e){
        e.preventDefault();

        this.setState({
            isLoadedPayouts: false
        });

        fetch(process.env.REACT_APP_API_URL + "/payouts", {
            method: "POST",
            body: JSON.stringify({
                'amount': e.target.amount.value,
                'user_id': this.state.userId,
                'admin_id': this.state.adminData.id,
                'partner_type': 'es',
            }),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(
                (result) => {
                    this.componentDidMount()

                    this.setState({
                        isLoadedPayouts: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.componentDidMount()

                    this.setState({
                        isLoadedPayouts: true
                    });
                }
            )
    }

    render() {
        const { isLoaded, isLoadedPayouts, isLoadedData, adminData, payouts, loginError, revenue, revenueIsLoaded} = this.state;

        const { navigate } = this.props;

        let content = "Loading...";

        if(isLoadedPayouts) {
            console.log(payouts.length);
        }

        if (isLoadedPayouts && payouts.length > 0){
            content = payouts.map(item => (
                    <div>
                        <h2>Payouts</h2>
                        <div className={item.status === 'in_review' ? "alert alert-warning" : "alert alert-success"}>
                            ${item.amount}
                            <br/>
                            {item.created_at}
                            <br/>
                            <a href={"/customer/" + item.user.id}>{item.user.email}</a>
                            <br/>
                            {item.status === 'in_review' ? "In review" : "Confirmed"}
                        </div>
                    </div>
                ))
        }

        if (loginError) {
            navigate('/account');
        }

        let revenueFormatted=null;
        if(revenueIsLoaded){
            revenueFormatted = <div class="alert alert-danger">
                <h3>Company revenue</h3>
                ${revenue}
                {revenue > 0 ? <form onSubmit={this.approvePayout.bind(this)}>
                    <input name="amount" type="number" hidden value={revenue}/>
                    <input type="submit" value="Proceed payout" className="btn btn-outline-danger"/>
                </form> : <span></span>}
            </div>
        }

        return <Container>
            <Row>
                <Col>
                    {revenueFormatted}
                    {content}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(CompanyRevenue);
